import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 mt-4 bg-white shadow rounded-2xl p-8" }
const _hoisted_2 = { class: "flex items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Start Date:", -1)
const _hoisted_4 = { class: "flex flex-row items-center justify-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-1.5" }, "Monthly Salary: ", -1)
const _hoisted_6 = {
  key: 0,
  class: "uppercase"
}
const _hoisted_7 = {
  key: 1,
  class: "uppercase"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UserCard, {
      id: _ctx.talent.id,
      firstName: _ctx.talent.first_name,
      lastName: _ctx.talent.last_name,
      position: _ctx.talent.job_title
    }, null, 8, ["id", "firstName", "lastName", "position"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _hoisted_3,
        _createVNode(_component_DateFormatter, {
          date: _ctx.talent.entry_day
        }, null, 8, ["date"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_ctx.currency === 'usd')
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " $" + _toDisplayString(((_ctx.talent.salary.monthly * _ctx.exchange_rate) / 100).toLocaleString(
            undefined,
            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
          )) + " " + _toDisplayString(_ctx.currency), 1))
        : _createCommentVNode("", true),
      (_ctx.currency === 'mxn')
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, " $" + _toDisplayString((_ctx.talent.salary.monthly / 100).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })) + " " + _toDisplayString(_ctx.currency), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}